import React from 'react'
import propTypes from 'prop-types'
import Week from '../Week/Week'

const Weekly = (
  { 
    date, 
    weeks, 
    timeSheet, 
    updateTimeSheet }) => {
    return (
      <div className='weeks'>
        {Object.keys(weeks).map(key => {
          return (
            <Week
              key={key}
              weekNumber={key}
              date={date}
              week={weeks[key]}
              timeSheet={timeSheet}
              updateTimeSheet={updateTimeSheet}
            />
          )
        })}
      </div>
    )
}

Weekly.propTypes = {
  date: propTypes.object,
  weeks: propTypes.object,
  timeSheet: propTypes.object,
  updateTimeSheet: propTypes.func
}

export default Weekly



// WEBPACK FOOTER //
// ./src/components/Weekly/Weekly.js